import React, { useEffect, useRef, useState } from 'react';
import { hhmm, localParts, weekdayDate, zonedToUtc } from '../lib/time';
import { PIN_COLORS } from './Board';

/** Create or edit a pin: a label and an instant, shown in every city's local time. */
export default function PinDialog({ pin, cities, onSave, onDelete, onClose }) {
  const home = cities[0];
  const p0 = localParts(home.timezone, pin.t);
  const [label, setLabel] = useState(pin.label);
  const [color, setColor] = useState(pin.color || 'blue');
  const [time, setTime] = useState(hhmm(p0));
  const [date, setDate] = useState(p0.date);
  const input = useRef(null);

  useEffect(() => {
    input.current?.focus();
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const t = zonedToUtc(date, time, home.timezone);

  const submit = (e) => {
    e.preventDefault();
    onSave({ ...pin, t, label: label.trim() || 'Meeting', color });
  };

  return (
    <div className="scrim" onMouseDown={onClose}>
      <form className="dialog" onMouseDown={(e) => e.stopPropagation()} onSubmit={submit} aria-label="Pin a time">
        <h3>{onDelete ? 'Edit pin' : 'Pin a time'}</h3>
        <label className="field">
          Label
          <input ref={input} value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Team standup" maxLength={60} />
        </label>
        <div className="field-row">
          <label className="field">
            Date ({home.name})
            <input type="date" value={date} onChange={(e) => e.target.value && setDate(e.target.value)} />
          </label>
          <label className="field">
            Time ({home.name})
            <input type="time" step="900" value={time} onChange={(e) => setTime(e.target.value)} />
          </label>
        </div>
        <div className="swatches" role="radiogroup" aria-label="Colour">
          {Object.entries(PIN_COLORS).map(([name, hex]) => (
            <button
              key={name}
              type="button"
              role="radio"
              aria-checked={color === name}
              aria-label={name}
              className={`swatch${color === name ? ' on' : ''}`}
              style={{ '--c': hex }}
              onClick={() => setColor(name)}
            />
          ))}
        </div>
        <ul className="pin-preview">
          {cities.map((c) => {
            const p = localParts(c.timezone, t);
            return (
              <li key={c.name}>
                <span>{c.name}</span>
                <span className="mono">{hhmm(p)} <small>{weekdayDate(c.timezone, t)}</small></span>
              </li>
            );
          })}
        </ul>
        <div className="dialog-actions">
          {onDelete && <button type="button" className="btn ghost danger" onClick={onDelete}>Delete</button>}
          <span className="spacer" />
          <button type="button" className="btn ghost" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn primary">Save pin</button>
        </div>
      </form>
    </div>
  );
}
